














































































import {defineComponent} from "@vue/composition-api";
import SelectDropdown from "@tool/Components/SelectDropdown.vue";
import {SelectDropdownInitParameter, SelectOption} from "@tool/Components/SelectDropdownInit";
import useBuilderStore from "@tool/store/useBuilderStore";
import ParameterNameGenerator from "@tool/Helpers/ParameterNameGenerator";
import {ParameterType} from "@tool/tool.types";

export default defineComponent({
    components: {
        SelectDropdown
    },
    emits: [
        'opened'
    ],
    props: {
        horizontal: {
            type: Boolean,
            default: false
        },
    },
    setup() {

        const {
            projectBuilderSettings,
            projectParameters,
            selectParameter,
            addParameter,
            clearParameters,
            formParameters,
        } = useBuilderStore();

        const campaignProps = SelectDropdownInitParameter('utm_campaign', projectParameters.value.utm_campaign, projectBuilderSettings.value);
        const sourceProps = SelectDropdownInitParameter('utm_source', projectParameters.value.utm_source, projectBuilderSettings.value);
        const mediumProps = SelectDropdownInitParameter('utm_medium', projectParameters.value.utm_medium, projectBuilderSettings.value);
        const contentProps = SelectDropdownInitParameter('utm_content', projectParameters.value.utm_content, projectBuilderSettings.value);
        const termProps = SelectDropdownInitParameter('utm_term', projectParameters.value.utm_term, projectBuilderSettings.value);

        const onParameterChanged = (type: ParameterType, option: SelectOption | null) => {
            selectParameter(type, option ? option.name : null);
        }

        const onParameterCreated = async (type: ParameterType, name: string) => {
            await addParameter(type, ParameterNameGenerator(name, projectBuilderSettings.value));
        }

        const onParameterClear = (type: ParameterType) => {
            clearParameters(type);
        }

        return {
            formParameters,

            campaignProps,
            sourceProps,
            mediumProps,
            contentProps,
            termProps,

            onParameterChanged,
            onParameterCreated,
            onParameterClear,

        }
    }
});
